import React from "react";
import HeaderDescription from "../components/HeaderDescription";
import ProfileHeaderSection from "../components/ProfileHeaderSection";
import { FowardButton } from "../components/forms/DashboardButton";
import HeaderBox from "../components/Box/HeaderBox";

import Screen from "../components/Screen"; 
import { useNavigate } from "react-router-dom";
import UnionSet from "../components/UnionSet";
import { useGetTrueNorth } from "../hooks/useGoals";

const North = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/quarterly-goals");
  };

  const { goals, isPending } = useGetTrueNorth();

  const hospital = goals?.hospital ?? 0;
  const revenue = goals?.reveune ?? 0;
  const spent = goals?.spent ?? 0;
  return (
    <div className="bg-white w-full">
      <Screen>
        <ProfileHeaderSection />

        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Unicorn Gang"}
          subsubtext={"True North"}
        />
        <p className={` text-4xl text-lightDark my-4`}>True North</p>
        <div className="">
          <HeaderBox text="What We Need to Achieve Unicorn Status" />
        </div>
        <div className={` text-black  mt-4 text-basetext leading-7 text-left`}>
          A unicorn is a startup company valued at USD 1 billion or more. Here’s
          how we plan to achieve this:
        </div>

        <div className="w-full flex flex-col lg:flex-row justify-between lg:h-96 h-screen rounded mt-4 bg-orange gap-2">
          <div className="lg:w-6/12  px-2 py-4 h-5/6 flex flex-col justify-center ">
            <p className={`text-black text-3xl mb-4 `}>
              The <span className={`text-lightRed text-2xl `}>Market</span>
            </p>
            <div>
              <p className={`text-black  text-basetext leading-7`}>
                LifeBank is on a mission to save lives across Africa by
                delivering critical life-saving supplies, such as blood, oxygen,
                medical samples, consumables, PPE, and rare medicines, to
                hospitals using technology and a multi-modal distribution
                platform.
              </p>
            </div>
          </div>
          <div className="lg:w-6/12 flex  items-start justify-center h-full">
            <div className="flex items-center h-2/5 justify-center">
              <UnionSet
                hospital={hospital}
                spent={spent}
                revenue={revenue}
                loading={isPending}
              />
            </div>
          </div>
        </div>
        <div className="my-4 flex justify-end">
          <FowardButton
            text={"Next"}
            onClick={handleNext}
            subText={"Quarterly goals"}
          />
        </div>
      </Screen>
    </div>
  );
};

export default North;
